import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="mt-6 relative border-t border-apb-border-soft bg-apb-surface/55 py-6 text-white apb-glass-panel overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-0.5 bg-gradient-to-r from-transparent via-apb-accent-cyan to-transparent opacity-80" />
      <div className="container mx-auto relative z-10 flex flex-col items-center justify-between gap-4 px-6 md:flex-row">
        <div className="flex items-center space-x-2 rounded-full border border-apb-border-soft bg-black/20 px-3 py-1.5">
          <Link to="/" aria-label="Afterparty Bot Labs home">
            <img src="/logo.png" alt="Afterparty Bot Labs" className="h-8 w-8" />
          </Link>
          <span className="text-sm text-apb-text-secondary">
            Afterparty Bot Labs <span className="text-apb-accent-cyan">© 2026</span> | All Rights Reserved
          </span>
        </div>

        <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm" aria-label="Footer navigation">
          <Link to="/" className="rounded-md px-2 py-1 text-apb-text-secondary transition-colors duration-240 hover:text-white hover:bg-white/10 focus-visible:outline-none focus-ring-neo">Home</Link>
          <Link to="/about" className="rounded-md px-2 py-1 text-apb-text-secondary transition-colors duration-240 hover:text-white hover:bg-white/10 focus-visible:outline-none focus-ring-neo">About Us</Link>
          <Link to="/support-us" className="rounded-md px-2 py-1 text-apb-text-secondary transition-colors duration-240 hover:text-white hover:bg-white/10 focus-visible:outline-none focus-ring-neo">Support Us</Link>
          <Link to="/contact" className="rounded-md px-2 py-1 text-apb-text-secondary transition-colors duration-240 hover:text-white hover:bg-white/10 focus-visible:outline-none focus-ring-neo">Contact Us</Link>
          <Link to="/privacy" className="rounded-md px-2 py-1 text-apb-text-secondary transition-colors duration-240 hover:text-white hover:bg-white/10 focus-visible:outline-none focus-ring-neo">Privacy</Link>
          <Link to="/tos" className="rounded-md px-2 py-1 text-apb-text-secondary transition-colors duration-240 hover:text-white hover:bg-white/10 focus-visible:outline-none focus-ring-neo">Terms</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;


